export interface BasicListOption<T> {
  value: T;
  label: string;
}

export enum LargeListFilterOperation {
  IS_ANY_OF_THESE = 'IS_ANY_OF_THESE',
  IS_NONE_OF_THESE = 'IS_NONE_OF_THESE',
}

export enum FunnelStepLargeListFilterOperation {
  IS_ANY_OF_THESE = 'IS_ANY_OF_THESE',
}

export interface LargeListFilterValue<T> {
  operation: LargeListFilterOperation;
  selectedValues: T[];
}
